import React from "react";
import { jsPDF } from "jspdf";
import footerLogo from "../../images/footer_logo_filled.jpg";
import baseURL from "../url";


function limpiarTexto(texto) {
  return texto
    .normalize("NFD")                    // separa letras y acentos
    .replace(/[\u0300-\u036f]/g, "")    // elimina los acentos
    .replace(/\s+/g, "_")               // espacios por guión bajo
    .replace(/[^a-zA-Z0-9_]/g, "");     // quita lo que no sea letra, número o _
}

// Función que genera y descarga el PDF
const generarPdfBytes = (detallesTurno) => {
    const doc = new jsPDF();
    const pdfWidth = doc.internal.pageSize.getWidth();
    const margin = 15;
    const colorInstitucional = "#14A7A3"; // Color institucional

    // HEADER
    doc.setFillColor(colorInstitucional);
    doc.rect(0, 0, pdfWidth, 30, "F"); // Fondo del header

    // Agregar logo en el header
    const logoWidth = 32, logoHeight = 20;
    doc.addImage(footerLogo, "JPG", margin, 2.5, logoWidth, logoHeight);

    // Título del header
    doc.setFontSize(16);
    doc.setTextColor("#FFFFFF");
    doc.text("Confirmación de Cita", pdfWidth / 2, 20, { align: "center" });

    // Título principal del contenido
    doc.setFontSize(22);
    doc.setTextColor("#2c3e50");
    doc.text("Detalles de la cita", pdfWidth / 2, 45, { align: "center" });

    // Línea de separación
    doc.setDrawColor(colorInstitucional);
    doc.setLineWidth(0.5);
    doc.line(margin, 50, pdfWidth - margin, 50);

    // Información del Turno
    doc.setFontSize(14);
    doc.setTextColor("#34495e");
    let currentY = 60;

    doc.text(`Cita N°: ${detallesTurno.idTurno}`, margin, currentY);
    currentY += 8;
    doc.text(`Servicio: ${detallesTurno.servicio}`, margin, currentY);
    currentY += 8;
    doc.text(`Día: ${detallesTurno.dia}`, margin, currentY);
    currentY += 8;
    doc.text(`Fecha: ${detallesTurno.fecha}`, margin, currentY);
    currentY += 8;
    doc.text(`Horario: ${detallesTurno.horarioInicio} - ${detallesTurno.horarioFin}`, margin, currentY);
    currentY += 12;

    // Datos del Cliente
    doc.setFontSize(16);
    doc.setTextColor(colorInstitucional);
    doc.text("Datos del Paciente", margin, currentY);
    currentY += 4;

    // Fondo para los datos del cliente
    doc.setFillColor("#f7f7f7");
    doc.roundedRect(margin, currentY + 2, pdfWidth - margin * 2, 25, 3, 3, "F");
    currentY += 12;
    doc.setFontSize(14);
    doc.setTextColor("#34495e");
    doc.text(`Nombre: ${detallesTurno.nombre}`, margin + 5, currentY);
    currentY += 8;
    doc.text(
        `Whatsapp: ${detallesTurno.telefono.replace(/-/g, "")}`,
        margin + 5,
        currentY
    );
    currentY += 15;

    // FOOTER
    const footerHeight = 20;
    doc.setFillColor(colorInstitucional);
    doc.rect(0, doc.internal.pageSize.getHeight() - footerHeight, pdfWidth, footerHeight, "F");

    // Texto del footer
    doc.setFontSize(12);
    doc.setTextColor("#FFFFFF");
    doc.text(
        "Universidad Autónoma de Queretaro",
        pdfWidth / 2,
        doc.internal.pageSize.getHeight() - 12,
        { align: "center" }
    );

    // Agregar logo en el footer
    const footerLogoWidth = 23, footerLogoHeight = 14;
    doc.addImage(
        footerLogo,
        "PNG",
        pdfWidth - margin - footerLogoWidth,
        doc.internal.pageSize.getHeight() - footerLogoHeight - 2,
        footerLogoWidth,
        footerLogoHeight
    );

    // Crear nombre de archivo seguro
    const nombreArchivo = `Cita_${detallesTurno.idTurno}_${detallesTurno.nombre
        .replace(/\s+/g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "")}_${detallesTurno.fecha
            .replace(/\s+/g, "_")
            .replace(/[^a-zA-Z0-9_]/g, "")}.pdf`;

    // Descargar el PDF
    // doc.save(nombreArchivo);
    const pdfBytes = doc.output('arraybuffer');

    return pdfBytes;
};

// export default descargarCitaPdf;

// Función para enviar el PDF al servidor
const enviarPdfAlServidor = async (detallesTurno) => {
    try {
        return await insertarNotificacion({ ...detallesTurno });
    } catch (error) {
        return { success: false, error: error.message };
    }
};

// Función para insertar notificación en la base de datos
const insertarNotificacion = async (detallesTurno) => {
    try {

        // Generar el PDF
        const pdfBytes = generarPdfBytes(detallesTurno);

        // Convertir ArrayBuffer a Blob
        const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

        // Crear FormData para enviar
        const formData = new FormData();

        // Crear nombre de archivo
        const nombreArchivo = `Cita_${detallesTurno.idTurno}_${limpiarTexto(detallesTurno.nombre)}_${limpiarTexto(detallesTurno.fecha)}.pdf`;


        formData.append('pdf', pdfBlob, nombreArchivo);

        // Realizar petición al servidor
        const response = await fetch(`${baseURL}/crearPDF.php`, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();

        if (response.ok) {
            return { success: true, data: result };
        } else {
            return { success: false, error: result.error || 'Error al insertar notificación' };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export default enviarPdfAlServidor;